var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doctor"},[_c('img',{attrs:{"src":_vm.doctor.image}}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.doctor.name))]),_c('span',[_vm._v(_vm._s(_vm.doctor.specialization))])])}
var staticRenderFns = []

export { render, staticRenderFns }